export default __webpack_public_path__ + "static/media/fun-target-bg_1.fdd9f10c.png";